import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../hooks";
import { useState, useEffect } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useForm } from "react-hook-form";
const Index = () => {
  const passwordRef = useRef<HTMLInputElement>(null);
  const auth = useAuthContext();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const onSubmit = async (e: any) => {
    e.preventDefault();
    auth
      ?.newPasswordChallenge(passwordRef?.current?.value || "")
      .then((e: any) => {
        if (e?.statusCode === 200) {
          navigate("/");
        }
      });
  };
  const handlePasswordChange = (event: any) => {
    setPassword(event.target.value);
  };
  useEffect(() => {
    if (!auth.user) {
      navigate("/");
    }
  }, [auth?.user]);
  return (
    <div className="container p-3 d-flex flex-column min-vh-100 min-vw-100">
      <div className=" d-flex flex-grow-1 justify-content-center align-items-center ">
        <div className="auth-container container d-flex flex-column  p-4 justify-content-center align-items-center">
          <div className="fs-3">XBI4 LogIn</div>

          <form onSubmit={onSubmit}>
            <div className="form-group my-2">
              <label htmlFor="password">New Password</label>
              <input
                type={showPassword ? "" : "password"}
                className="form-control"
                id="password"
                placeholder="Password"
                value={password}
                ref={passwordRef}
                onChange={handlePasswordChange}
              />
              <button
                type="button"
                className="eyePassword"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
            <button onClick={onSubmit} className="btn btn-primary my-2">
              Log In
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Index;
